<template>
  <div>
    <select-payment-method
      v-if="!uuid && isLoggedIn"
      @checkout="commenceCheckout"
      :cart="cart"
      :removeFromCart="removeFromCart"
    />
    <component
      v-else-if="uuid && isLoggedIn"
      :is="renderMethodComponent()"
      :uuid="uuid"
      :method="selected"
      :qr="qr"
      :expiryTimestamp="expiryTimestamp"
      :paymentUrl="paymentUrl"
      @failed="handleFailedPayment"
      @success="handleSuccessfulPayment"
    />
  </div>
</template>

<script>
import SelectPaymentMethod from '@/components/Checkout/SelectPaymentMethod'
import PaylahWeb from '@/components/Checkout/Pending/PaylahWeb'
import PaylahOnTile from '@/components/Checkout/Pending/PaylahOnTile'
import PayNow from '@/components/Checkout/Pending/PayNow'
import PayAnyone from '@/components/Checkout/Pending/PayAnyone'
import CreditCard from '@/components/Checkout/Pending/CreditCard'
import Modal from '@/components/Modal'
import beepAPI from '@/mixins/beepAPI'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Checkout',
  metaInfo () {
    return {
      title: 'Checkout',
      // meta: [
      //   { property: 'og:title', content: 'Checkout' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'Checkout' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-04.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    SelectPaymentMethod,
    PaylahWeb,
    PaylahOnTile,
    PayNow,
    PayAnyone,
    CreditCard,
    Modal
  },
  mixins: [beepAPI],
  props: {},
  data () {
    return {
      selected: null,
      uuid: null,
      paymentStatus: null,
      qr: null,
      expiryTimestamp: null,
      paymentUrl: '',
      cart: []
    }
  },
  computed: {
    ...mapState(['products', 'quotas', 'purchasing', 'isPayLahTile', 'isLoggedIn']),
    ...mapGetters(['totalAmount'])
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    if (this.isLoggedIn) {
      this.handleLoadPage()
        .then(
          () => {
            const uuid = this.$route.query.uuid
            if (this.totalAmount === 0 && !uuid) {
              this.$router.push({ name: 'Purchase', query: this.$route.query })
            }

            if (uuid) {
              this.uuid = uuid
              this.selected = JSON.parse(decodeURIComponent(this.$route.query.selected))
              this.paymentStatus = 'pending'
              this.expiryTimestamp = Number(this.$route.query.expiryTimestamp)
            }

            const qr = this.$route.query.qr
            if (qr) {
              this.qr = qr
            }

            const encoded = this.$route.query.encoded
            if (encoded) {
              const decoded = decodeURIComponent(encoded)
              const json = JSON.parse(decoded)
              this.uuid = json.uuid
              this.selected = json.selected
            }

            // if (this.isPayLahTile) {
            //   const body = {
            //     selectedPaymentOption: this.selected.scheme
            //   }

            //   this.commenceCheckout({ body, method: this.selected })
            // }
          }
        )
    } else {
      this.$router.push({ name: 'Home', query: this.$route.query })
    }
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  beforeRouteLeave (to, from, next) {
    switch (this.paymentStatus) {
      case 'success':
        next()
        break
      case 'pending':
        // if (confirm('By proceeding, you will be brought back to Order Summary page. This transaction will still be valid if you complete payment on your CreditCard/PayLah!/PayNow App.')) {
        //   this.handleFailedPayment()
        //   next()
        // } else {
        this.createModal({
          title: 'Transaction in Process',
          message: 'Please do not navigate away from this page as payment is still being processed.',
          btnMessage: 'OK',
          callback: () => {}
        })
        next(false)
        // }
        break
      default:
        next()
        break
    }
  },
  methods: {
    ...mapActions(['updateProducts', 'updateTransactionHistory', 'updatePurchasing', 'updateQuotas', 'updateFilteredPurchasing']),
    ...mapMutations(['setFilteredPurchasing']),

    async removeFromCart (sku) {
      if (Object.keys(this.purchasing).length === 1) {
        this.$router.go(-1)
      }
      const updatedCart = this.cart.filter(item => item.sku !== sku)
      this.cart = updatedCart
      const filteredPurchasing = this.purchasing
      delete filteredPurchasing[sku]

      await this.setFilteredPurchasing(filteredPurchasing)

      // const body = {
      //   items: Object.entries(this.purchasing)
      //     .map(([sku, qty]) => {
      //       return {
      //         sku: sku,
      //         quantity: qty
      //       }
      //     })
      // }

      // this.putCart(body)
      //   .catch(console.error)
    },

    commenceCheckout ({ body, method }) {
      this.setIsLoading(true)
      this.postSelectedPaymentMethod(body)
        .then(
          response => {
            this.setIsLoading(false)
            const { success, uuid, message, qr, expiryTimestamp, url } = response
            if (success) {
              this.selected = method
              this.paymentStatus = 'pending'
              this.uuid = uuid
              this.expiryTimestamp = expiryTimestamp
              if (method.scheme === 'paynow') {
                this.qr = qr
                this.$router.replace({
                  query: {
                    uuid: this.uuid,
                    selected: encodeURIComponent(JSON.stringify(this.selected)),
                    expiryTimestamp: `${expiryTimestamp}`,
                    qr: this.qr
                  }
                })
              } else if (method.scheme === 'credit_card') {
                this.paymentUrl = url
                this.$router.replace({
                  query: {
                    uuid: this.uuid,
                    selected: encodeURIComponent(JSON.stringify(this.selected)),
                    expiryTimestamp: `${expiryTimestamp}`
                  }
                })
              } else if (method.scheme === 'paylah_tilecheckout') {
                this.$router.replace({
                  query: {
                    uuid: this.uuid,
                    selected: encodeURIComponent(JSON.stringify(this.selected)),
                    expiryTimestamp: `${expiryTimestamp}`,
                    isPayLahTile: true
                  }
                })
              } else if (method.scheme === 'ocbc_pao') {
                this.qr = qr
                // const queryValue = {
                //   uuid: this.uuid,
                //   selected: this.selected
                // }

                this.$router.replace({
                  query: {
                    // encoded: encodeURIComponent(JSON.stringify(queryValue)),
                    uuid: this.uuid,
                    selected: encodeURIComponent(JSON.stringify(this.selected)),
                    expiryTimestamp: `${expiryTimestamp}`,
                    qr
                  }
                })
              } else {
                this.$router.replace({
                  query: {
                    uuid: this.uuid,
                    selected: encodeURIComponent(JSON.stringify(this.selected)),
                    expiryTimestamp: `${expiryTimestamp}`
                  }
                })
              }
            } else {
              let errMsg = message
              if (errMsg === 'EmptyAuthHeader') {
                // This happens if the API server token is not working for some reason
                errMsg = 'Transaction could not be processed, please try again later.'
              }
              this.createModal({
                title: 'Something went wrong',
                message: `${errMsg}`,
                btnMessage: 'Ok',
                callback: () => {
                  this.uuid = null
                  this.paymentStatus = null
                  if (this.isPayLahTile) this.$router.push({ name: 'Purchase', query: this.$route.query })
                  this.setIsLoading(false)
                }
              })
            }
          },
          (error) => {
            if (this.isPayLahTile) {
              this.uuid = null
              this.paymentStatus = null
              this.createModal({
                title: 'Something went wrong',
                message: 'Please try again',
                btnMessage: 'Ok',
                callback: () => {
                  this.uuid = null
                  this.paymentStatus = null
                  this.$router.push({ name: 'Purchase', query: this.$route.query })
                  this.setIsLoading(false)
                }
              })
            } else {
              this.uuid = null
              this.paymentStatus = null

              if (error.response.status === 429) {
                this.createModal({
                  title: '',
                  message: 'We are currently experiencing a surge. Please try again later.',
                  btnMessage: 'OK',
                  callback: () => {
                    this.uuid = null
                    this.paymentStatus = null
                    this.setIsLoading(false)
                    // this.$router.push({ name: 'Purchase', query: this.$route.query })
                  }
                })
              } else if (body.selectedPaymentOption === 'paylah_webcheckout' && error.response.status === 400) {
                this.createModal({
                  title: 'Something went wrong with the payment process',
                  message: "We are unable to process your request with PayLah!<br/><br/>Please download and install PayLah! at <a href='www.dbs.com.sg/dbspaylah'>www.dbs.com.sg/dbspaylah</a> or select other payment modes.",
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.uuid = null
                    this.paymentStatus = null
                    this.setIsLoading(false)
                  }
                })
              } else {
                this.createModal({
                  title: 'Something went wrong',
                  message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.uuid = null
                    this.paymentStatus = null
                    this.setIsLoading(false)
                    // this.$router.push({ name: 'Purchase', query: this.$route.query })
                  }
                })
              }
            }
          }
        )
    },

    renderMethodComponent () {
      switch (this.selected.scheme) {
        case 'paylah_webcheckout':
          return 'PaylahWeb'
        case 'paylah_tilecheckout':
          return 'PaylahOnTile'
        case 'paynow':
          return 'PayNow'
        case 'ocbc_pao':
          return 'PayAnyone'
        case 'credit_card':
          return 'CreditCard'
      }
    },

    handleFailedPayment () {
      if (this.isPayLahTile) {
        this.uuid = null
        this.paymentStatus = null
        this.expiryTimestamp = null
        this.$router.push({ name: 'Purchase', query: this.$route.query })
      } else {
        this.$router.replace('/checkout')
        this.uuid = null
        this.paymentStatus = null
        this.expiryTimestamp = null
        this.qr = null
      }
    },

    handleSuccessfulPayment () {
      this.paymentStatus = 'success'
      this.$router.push(
        { name: 'SuccessfulCheckout', query: this.isPayLahTile ? { isPayLahTile: 'true' } : {} },
        () => {
          this.uuid = null
        }
      )
    },
    handleFetchProducts () {
      return new Promise((resolve, reject) => {
        this.getProducts()
          .then(
            response => {
              this.updateProducts(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch products.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchTransactionHistory () {
      return new Promise((resolve, reject) => {
        this.getTransactionHistory()
          .then(
            response => {
              this.updateTransactionHistory(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch transaction history.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchQuotas () {
      return new Promise((resolve, reject) => {
        this.getQuotas()
          .then(
            response => {
              this.updateQuotas(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch your remaining quotas.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchCart () {
      return new Promise((resolve, reject) => {
        this.getCart()
          .then(
            async response => {
              for await (const { sku, quantity } of response) {
                const product = this.products.find(product => product.sku === sku)
                const productQuota = this.quotas[sku]
                product.remainingQuota = productQuota
                this.cart.push(product)
                this.updatePurchasing({ sku: sku, qty: quantity })
              }

              resolve(response)
            },
            error => {
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch cart.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleLoadPage () {
      this.setIsLoading(true)

      return new Promise((resolve, reject) => {
        Promise.all([
          this.handleFetchTransactionHistory(),
          this.handleFetchProducts(),
          this.handleFetchQuotas()
        ])
          .then(
            async result => {
              await this.handleFetchCart()
              this.setIsLoading(false)
              resolve()
            },
            error => {
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch transaction history and products.',
                btnMessage: 'Proceed',
                callback: () => {
                  this.$router.push({ name: 'Purchase', query: this.$route.query })
                  this.setIsLoading(false)
                  reject(error)
                }
              })
            }
          )
      })
    }
  }
}
</script>

<style scoped>
</style>
